// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MZPFV{line-height:normal;text-align:center;white-space:nowrap}li .MZPFV{margin-left:calc(var(--unit)/2)}", "",{"version":3,"sources":["webpack://./src/components/organisms/filters/cancelAllFiltersButton/cancelAllFiltersButton.module.scss"],"names":[],"mappings":"AAEA,OACI,kBAAA,CACA,iBAAA,CACA,kBAAA,CAEA,UACI,+BAAA","sourcesContent":["@use 'serp-global-styles/config/mixins' as *;\n\n.filter-cancel {\n    line-height: normal;\n    text-align: center;\n    white-space: nowrap;\n\n    li & {\n        margin-left: calc(var(--unit) / 2);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filter-cancel": "MZPFV",
	"filterCancel": "MZPFV"
};
export default ___CSS_LOADER_EXPORT___;
